/**
 * Dati di contatto dei referenti dei fornitori e dei fornitori (nome della persona, email, telefono, indirizzo):
 * nelle immagini delle segnalazioni (FBK26) non devono mai comparire in chiaro. L'SDK oscura prima della cattura ogni
 * elemento con `data-sensitive` o dentro uno, più i selettori `SENSITIVE_MASK_SELECTORS` (le tendine antd, che finiscono
 * in un portal su body e quindi fuori da ogni antenato marcato).
 *
 * Si marca la cella o il blocco, non la pagina intera. Il test `frontend/test/sensitive.test.ts` fallisce se uno di
 * questi campi compare fuori da un antenato marcato.
 */
import { Select, type SelectProps } from "antd";
import type { ReactNode } from "react";

/** Classe delle tendine (portal su body) che mostrano dati di contatto. */
export const SENSITIVE_POPUP = "ap-sensitive-popup";
/** Passati all'SDK come `maskSelectors`. */
export const SENSITIVE_MASK_SELECTORS = [`.${SENSITIVE_POPUP}`];

/** Avvolge un dato di contatto: `span` in linea, `block` per un `div`. */
export function Sensitive({ children, block }: { children?: ReactNode; block?: boolean }) {
  return block ? <div data-sensitive="">{children}</div> : <span data-sensitive="">{children}</span>;
}

/** Select con dati di contatto: marcata lei e la sua tendina, che sta nel portal. */
export function SensitiveSelect<V = unknown>(props: SelectProps<V>) {
  const { classNames, ...rest } = props;
  return (
    <Select<V>
      data-sensitive=""
      {...rest}
      classNames={{ ...classNames, popup: { ...classNames?.popup, root: [classNames?.popup?.root, SENSITIVE_POPUP].filter(Boolean).join(" ") } }}
    />
  );
}
